import { FunctionComponent } from "react";

import { Button } from "@/components/Button/Button";
import { ButtonColor, ButtonSize } from "@/components/Button/types";

import { LiPostType } from "@/enum/liprofile.enum";

interface LiPostTypeSelectorProps {
	selectedType?: LiPostType;
	onSelect: (type: LiPostType) => void;
}

const TYPE_OPTIONS: { type: LiPostType; title: string }[] = [
	{ type: LiPostType.BY_TOPIC, title: "Track posts about a topic" },
	{ type: LiPostType.BY_URL, title: "Track a specific post" },
	{ type: LiPostType.BY_PROFILE, title: "Track Linkedin profiles" },
];

export const LiPostTypeSelector: FunctionComponent<LiPostTypeSelectorProps> = ({
	selectedType,
	onSelect,
}) => (
	<div className="flex flex-row gap-4 w-full mb-4 flex-wrap">
		{TYPE_OPTIONS.map(({ type, title }) => (
			<div key={type} className="w-auto">
				<Button
					color={selectedType === type ? ButtonColor.ACTION : ButtonColor.ACTION_SECONDARY}
					size={ButtonSize.ML}
					title={title}
					onClick={() => onSelect(type)}
				/>
			</div>
		))}
	</div>
);
